"use strict";
var globalThis = require("../internals/global-this");
var DESCRIPTORS = require("../internals/descriptors");
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
module.exports = function(name) {
  if (!DESCRIPTORS) return globalThis[name];
  var descriptor = getOwnPropertyDescriptor(globalThis, name);
  return descriptor && descriptor.value;
};
